export const title = {
    voip: 'Позвоните в банк через Альфа-Онлайн',
    otherContacts: 'Другие контакты банка',
    otherContactsWithBackCallButtonFeat: 'Другие способы связи',
};
export const titleWebview = {
    voip: 'Позвоните в банк через приложение',
    otherContacts: 'Другие контакты банка',
};
